import ConfirmPanel from './ConfirmPanel';

export default ConfirmPanel;
